export default __webpack_public_path__ + "static/media/SlideFour.4f7f248c.png";